import React, {useContext, useEffect} from 'react'
import {useWeb3React} from '@web3-react/core'
import {TRIAS_SELECTED_WEB3_CONTEXT} from '../const'
import {InjectedConnector} from '@web3-react/injected-connector'
import {PopupItem} from "../components/common/Popup";
import {mainContext} from "../reducer";
import {TransactionsUpdater} from "../hooks";
import styled from "styled-components";

const injected = new InjectedConnector({
    supportedChainIds: [1, 3, 4, 5, 56, 66,42, 97,128, 137],
})

const PopupColumn = styled.div`
  position: fixed;
  top: 140px;
  right: 4rem;
  max-width: 355px !important;
  z-index: 3;

  @media #{$mobile} {
    top: 0;
    right: 0;
  }
`

const wallets = {
    MetaMask: injected
}

export const InitPage = () => {

    const {popupList} = useContext(mainContext).state
    const context = useWeb3React()
    const {activate} = context

    useEffect(() => {
        const localContent =
            window && window.localStorage.getItem(TRIAS_SELECTED_WEB3_CONTEXT)
        if (localContent) {
            activate(wallets[localContent])
        }
    }, [activate])

    return (
        <>
            <TransactionsUpdater/>
            <PopupColumn>
                {popupList.map((item) => {
                    return (
                        <PopupItem
                            key={item.key}
                            popKey={item.key}
                            hash={item.hashLink}
                            content={item.summary}
                            success={item.success}
                            removeAfterMs={4000}
                        />
                    )
                })}
            </PopupColumn>
        </>
    )
}
